import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Breadcrumb } from "../../models/breadcrumb";
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BreadcrumbComponent implements OnInit {

  @Input()
  crumbs: Breadcrumb[]
  faChevronRight=faChevronRight
  constructor() { }

  ngOnInit() {
  }

}
